import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, TablePagination } from "@mui/material";
import { RowTableSpecialist } from "./RowTableSpecialist";
import ModalDetailsSpecialist from "../ModalDetailsSpecialist";
import ModalRsetPasswordSpecialist from "../ModalRsetPasswordSpecialist";
import EditSpecialistModal from "../ModalEditSpecialist";

export default function TableSpecialist({ rows = [], setLoading, type }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [openModalDetails, setOpenModalDetails] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [showModalEditSpecialist, setShowModalEditSpecialist] =
    React.useState(false);
  const [showModalResetPassword, setShowModalResetPassword] =
    React.useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = React.useMemo(() => {
    if (!rows || rows.length === 0) return [];

    return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, rows]);
  return (
    <>
      {selectedUser && (
        <ModalDetailsSpecialist
          open={openModalDetails}
          setOpen={setOpenModalDetails}
          userData={selectedUser}
        />
      )}
      {selectedUser && (
        <EditSpecialistModal
          open={showModalEditSpecialist}
          setOpen={setShowModalEditSpecialist}
          setLoading={setLoading}
          specialistData={selectedUser}
        />
      )}
      {selectedUser && (
        <ModalRsetPasswordSpecialist
          open={showModalResetPassword}
          setLoading={setLoading}
          setOpen={setShowModalResetPassword}
          userData={selectedUser}
        />
      )}
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>Nombre</TableCell>
                  <TableCell align="center">Apellidos</TableCell>
                  <TableCell align="center">Especialidad</TableCell>
                  <TableCell align="center">Correo</TableCell>
                  <TableCell align="center">Teléfono</TableCell>
                  <TableCell align="center">Estado de la cuenta</TableCell>
                  <TableCell align="center">Membresía</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((row) => {
                  return (
                    <RowTableSpecialist
                      key={row._id}
                      row={row}
                      setSelectedUser={setSelectedUser}
                      setOpenModalDetails={setOpenModalDetails}
                      setShowModalResetPassword={setShowModalResetPassword}
                      setShowModalEditSpecialist={setShowModalEditSpecialist}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
}
